import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getPaymentsByBudgetHead } from "../../services/AppService";
import PageFade from "../../components/Login/PageFade";
import closeButton from '../../assets/images/close.png';
import { resolveMediaUrl } from "../../utility/media";
import { useTranslation } from "react-i18next";

const OverBudgetPaymentDetailsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    // Get budgetHeadId from the state passed during navigation
    const { budgetHeadId, budgetName } = location.state || {};

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (budgetHeadId) {
            fetchPaymentDetails();
        }
    }, [budgetHeadId]);

    const fetchPaymentDetails = async () => {
        setLoading(true);
        try {
            const res = await getPaymentsByBudgetHead(budgetHeadId);
            setItems(res.content || []);
        } catch (error) {
            console.error("Error fetching payments", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-[#4e5ead]">
                        {t('pageTitles.overBudgetPaymentDetails')}: <span className="text-gray-600">{budgetName}</span>
                    </h4>
                    <img
                        src={closeButton}
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => navigate(-1)}
                    />
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full border text-sm ctable">
                        <thead>
                            <tr className="bg-[#a0adf1] text-white">
                                <th className="px-4 py-3 border">{t('tables.srNo')}</th>
                                <th className="px-4 py-3 border">{t('work.workName')}</th>
                                <th className="px-4 py-3 border">{t('accounts.payment.budgetName')}</th>
                                <th className="px-4 py-3 border text-right">{t('accounts.payment.paymentAmount')}</th>
                                <th className="px-4 py-3 border">{t('common.attachments')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-4 py-3 border text-center">{idx + 1}</td>
                                    <td className="px-4 py-3 border font-medium">{item.workName}</td>
                                    <td className="px-4 py-3 border">{item.budgetName}</td>
                                    <td className="px-4 py-3 border text-right font-bold text-gray-600">
                                        {item.paymentAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                    </td>
                                    {/* <td className="p-2 text-center">
                                        {p.attachmentLocation && (
                                            <a href={resolveMediaUrl(p.attachmentLocation)} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline text-xs font-bold truncate inline-block max-w-[200px]">
                                                {p.attachmentName}
                                            </a>
                                        )}
                                    </td> */}
                                    <td className="px-4 py-3 border text-center">
                                        {item.attachmentLocation ? (
                                            <a href={resolveMediaUrl(item.attachmentLocation)} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline text-sm font-bold truncate inline-block max-w-[200px]">
                                                {item.attachmentName}
                                            </a>

                                        ) : (
                                            <span className="text-gray-400">-</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </PageFade>
    );
};

export default OverBudgetPaymentDetailsPage;